import { render, staticRenderFns } from "./addTicketConnectionsModal.vue?vue&type=template&id=972de544&scoped=true"
import script from "./addTicketConnectionsModal.vue?vue&type=script&lang=ts"
export * from "./addTicketConnectionsModal.vue?vue&type=script&lang=ts"
import style0 from "./addTicketConnectionsModal.vue?vue&type=style&index=0&id=972de544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972de544",
  null
  
)

export default component.exports